import React from "react";
import { useHistory, useRouteMatch } from "react-router";

import { Box } from "../../UI/Box";
import { ListItemText } from "../../UI/ListItemText";

import { ILink } from "./types";
import { useHeaderContext } from "../Header/context";

import { StyledListItemButton } from "./styles";
import { useNetwork } from "../../hooks/useNetwork";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { handleNavigation } from "../../helpers/handleNavigation";

export const SubNavItem: React.FC<ILink> = (props) => {
  const { push } = useHistory();
  const { selectedNetwork } = useNetwork();
  // Use baseUrl for matching if available (for pages with subtabs), otherwise use url
  const matchUrl = props.baseUrl || props.url || "";
  const isRouteMatch = useRouteMatch(matchUrl);
  const { closeNav } = useHeaderContext();
  const { isUpMd } = useMediaQuery();

  const handleNavClick = (event: React.MouseEvent) => {
    if (props.url) {
      handleNavigation(event, props.url, push);
    } else if (props.externalUrl) {
      window.open(props.externalUrl(selectedNetwork.apt));
    }

    if (!isUpMd) {
      closeNav();
    }
  };

  return (
    <StyledListItemButton selected={!!isRouteMatch} onClick={handleNavClick}>
      <Box width={24} height={24} mr={0.5}>
        <img src="/static/images/icons/dot.png" alt="Users" />
      </Box>
      <ListItemText primary={props.name} />
    </StyledListItemButton>
  );
};
